import { render, staticRenderFns } from "./themeSea.vue?vue&type=template&id=64d2f7cb&scoped=true&"
import script from "./themeSea.vue?vue&type=script&lang=js&"
export * from "./themeSea.vue?vue&type=script&lang=js&"
import style0 from "./themeSea.vue?vue&type=style&index=0&id=64d2f7cb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d2f7cb",
  null
  
)

export default component.exports